import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { MessageService } from '@app/core/message/services/message.service'
import { AppError } from '@app/core/message/models/error.model'
import { ErrorEnum } from '@app/core/message/models/error.enum'
import { NetworkService } from '../services/network.service'
import { environment } from '@env/environment'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private messageService: MessageService,
    private networkService: NetworkService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.networkService.connected) {
      const error: AppError = this.messageService.getErrorForLocaleCode(
        ErrorEnum.no_network
      )
      return throwError(error)
    }
    let req = next.handle(request)
    if (request.method === 'GET') {
      req = req.pipe(
        catchError((error: HttpErrorResponse) => {
          if (error && (error.status === 401 || error.status === 403)) {
            window.location.href = environment.loginUrl;
          }
          return throwError(error)
        })
      )
    }

    return req.pipe(
      catchError((error) => {
        let rError: AppError
        switch (error.status) {
          case 400:
            rError = this.messageService.getErrorForLocaleCode(
              ErrorEnum.bad_request
            )
            break
          case 401:
            rError = this.messageService.getErrorForLocaleCode(
              ErrorEnum.not_authenticated
            )
            break
          case 403:
            rError = this.messageService.getErrorForLocaleCode(
              ErrorEnum.not_authorized
            )
            break
          case 404:
            rError = this.messageService.getErrorForLocaleCode(
              ErrorEnum.not_found
            )
            break
          case 418:
            rError = this.messageService.getErrorForLocaleCode(ErrorEnum.teapot)
            break
          case 500:
            rError = this.messageService.getErrorForLocaleCode(
              ErrorEnum.internal_error
            )
            break
          default:
            rError = this.messageService.getErrorForLocaleCode(
              ErrorEnum.undefined
            )
            break
        }
        rError.additionalInfo = JSON.stringify(error ? error.error : '')
        return throwError(rError)
      })
    )
  }
}
